import { apiUrl } from "../../constants";
import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const updateVehicle = createAsyncThunk(
  "vehicle/updateVehicle",
  async (data, thunkAPI) => {
    const state = thunkAPI.getState();
    const token = state.user.token;

    // Build request payload dynamically
    const deliveryData = {
      vehicle_id: data.vehicleId,
      v_name: data.name,
      v_model: data.model,
      v_plate_number: data.plateNumber,
      v_width: data.width,
      v_height: data.height,
      v_depth: data.depth,
      v_trunk_capacity: data.trunkSize,
      images: data.image,
      v_driver_id: data.driver ? data.driver : null,
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(deliveryData),
    };

    try {
      const response = await fetch(`${apiUrl}/update_vehicle`, requestOptions);

      if (!response.ok) {
        let errorMessage = "Network response was not ok";
        try {
          const error = await response.json();
          errorMessage = error.msg || errorMessage;
        } catch (e) {
          errorMessage = await response.text();
        }
        throw new Error(errorMessage || "Unknown error occurred");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Updating vehicle failed:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const updateVehicleSlice = createSlice({
  name: "vehicle",
  initialState: {
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
    vehicle: null,
  },
  reducers: {
    resetUpdateVehicleState: (state) => {
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateVehicle.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateVehicle.fulfilled, (state, action) => {
        state.vehicle = action.payload;
        state.status = "success";
        state.error = null;
      })
      .addCase(updateVehicle.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { resetUpdateVehicleState } = updateVehicleSlice.actions;
export default updateVehicleSlice.reducer;
